module.exports = __webpack_public_path__ + "media/src/images/bg/bg6-db15c4cdc9c18e0c8444a378101d07c3.jpg";